module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('data-table', {
    attrs: {
      "title": _vm.tableTitle,
      "titleHeading": "h4",
      "table-ref": "checklisttable",
      "show-search": false,
      "url": _vm.url + "/checklist/" + (_vm.parentData.id),
      "fields": _vm.listFields,
      "sort-field": "id",
      "add-action": _vm.isSiteManager ? (_vm.percentComplete < 100 ? _vm.addActionComp : null) : null,
      "add-props": _vm.addProps
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function(props) {
        return [(props.rowData.name && props.rowData.category) ? _c('span', [_c('b', {
          staticClass: "text-primary"
        }, [_vm._v(_vm._s(props.rowData.name))]), _vm._v(" "), _c('small', [_vm._v("(" + _vm._s(props.rowData.category) + ")")])]) : _c('span', {
          staticClass: "text-primary"
        }, [_vm._v(_vm._s(props.rowData.name))])]
      }
    }, {
      key: "time",
      fn: function(props) {
        return [(props.rowData.taskTime && props.rowData.taskUnits) ? _c('strong', {
          staticClass: "text-primary"
        }, [_vm._v(_vm._s(props.rowData.taskTime) + " " + _vm._s(_vm.plural(props.rowData.taskUnits, props.rowData.taskTime)))]) : _c('span', [_vm._v("-")])]
      }
    }, {
      key: "status",
      fn: function(props) {
        return [(props.rowData.status === 'Finished') ? _c('span', {
          staticClass: " text-success"
        }, [_c('i', {
          staticClass: "fa fa-flag-checkered"
        }), _vm._v(" " + _vm._s(props.rowData.status))]) : _vm._e(), _vm._v(" "), (props.rowData.status === 'In Progress') ? _c('span', {
          staticClass: " text-primary"
        }, [_c('i', {
          staticClass: "fa fa-spinner fa-spin"
        }), _vm._v(" " + _vm._s(props.rowData.status))]) : _vm._e(), _vm._v(" "), (props.rowData.status === 'KIV') ? _c('span', {
          staticClass: "text-danger"
        }, [_c('i', {
          staticClass: "fa fa-minus"
        }), _vm._v(" " + _vm._s(props.rowData.status))]) : _vm._e(), _vm._v(" "), (props.rowData.status === 'Escalated') ? _c('span', {
          staticClass: "text-warning"
        }, [_c('i', {
          staticClass: "fa fa-plus"
        }), _vm._v(" " + _vm._s(props.rowData.status))]) : _vm._e(), _vm._v(" "), (props.rowData.status === 'Pending') ? _c('span', {
          staticClass: "text-info"
        }, [_c('i', {
          staticClass: "fa fa-clock"
        }), _vm._v(" " + _vm._s(props.rowData.status))]) : _vm._e(), _vm._v(" "), (props.rowData.grading && props.rowData.status === 'Finished') ? _c('span', [_c('el-rate', {
          attrs: {
            "disabled": true,
            "colors": ['#99A9BF', '#F7BA2A', '#FF9900']
          },
          model: {
            value: (props.rowData.grading),
            callback: function($$v) {
              _vm.$set(props.rowData, "grading", $$v)
            },
            expression: "props.rowData.grading"
          }
        })], 1) : _vm._e()]
      }
    }, {
      key: "photo",
      fn: function(props) {
        return [(_vm.isSite) ? _c('div', [(props.rowData.photoRequired) ? _c('el-button', {
          attrs: {
            "type": props.rowData.files === 2 ? 'success' : (props.rowData.files === 1 ? 'warning' : 'danger'),
            "size": "mini",
            "disabled": ""
          }
        }, [_c('i', {
          class: props.rowData.photoRequired ? 'fa fa-camera' : ''
        })]) : _vm._e()], 1) : _c('div', [_c('i', {
          class: props.rowData.photoRequired ? 'fa fa-check' : ''
        })])]
      }
    }, {
      key: "edit",
      fn: function(props) {
        return [(props.rowData.status !== 'Finished') ? _c('edit-checklist', {
          attrs: {
            "row-data": props.rowData,
            "parent-id": props.rowData.parent_id,
            "workflow-id": props.rowData.workflow_id,
            "site-id": props.rowData.site_id,
            "is-site": _vm.isSite
          }
        }) : _c('div', [(props.rowData.site_id) ? _c('edit-checklist', {
          attrs: {
            "row-data": _vm.clone(props.rowData),
            "is-view": "",
            "is-site": _vm.isSite
          }
        }) : _vm._e()], 1)]
      }
    }, {
      key: "delete",
      fn: function(props) {
        return [(props.rowData.status !== 'Finished' && _vm.isManager()) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.onDelete(props.rowData)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        })]) : _vm._e()]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08a7ede8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/workflow/checklist/ChecklistTable.vue
// module id = 1402
// module chunks = 0